export default {
    initialColorMode: "light",
    useSystemColorMode: false,
};
